// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.pagination[data-v-4d68f1ca] { text-align: right; margin-top: 20px;\n}\n.muted[data-v-4d68f1ca] { color: #999; font-size: 12px;\n}\r\n", ""]);
// Exports
module.exports = exports;
